module.exports = __webpack_public_path__ + "static/media/airtable.b509235e.svg";